import {action, observable} from 'mobx'
import {notification} from 'antd'
import Validator from 'validatorjs'

import {defaults, rules, customErrorMessages} from './consts/passwordChange'

export class PasswordChange {
  @observable data = {...defaults}
  @observable errors = {...defaults}
  @observable loading = false

  constructor(rootStore, api) {
    this.root = rootStore
    this.api = api
  }

  @action change(key, value) {
    this.data[key] = value
  }

  @action blank() {
    this.data = {...defaults}
  }

  @action validate() {
    const validation = new Validator(this.data, rules, customErrorMessages)
    const passes = validation.passes()
    if (!passes) {
      for (let name in this.errors) {
        this.errors[name] = validation.errors.first(name)
      }
    }
    return passes
  }

  @action submit = async () => {
    this.loading = true
    try {
      await this.api.request('user/change-password', 'post', this.data)
      this.root.auth.logout()
      this.blank()
      notification['success']({
        message: 'Your password has been successfully changed'
      })
    } catch (e) {
      notification['error']({
        message: 'Failed to change password',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.loading = false
    }
  }
}
